import * as React from 'react';
import * as styles from './styles.css';

import { UIText1 } from '@cian/ui-kit';
import { IconFunctionalSuccess16, IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { IMyHomeStatusInfoSchema } from '../../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';

interface IStatusListProps {
  collapsed: boolean;
  setCollapsed(): void;
  currentStatus: IMyHomeStatusInfoSchema;
  statusList: IMyHomeStatusInfoSchema[];
  onSetNewStatus(status: IMyHomeStatusInfoSchema): void;
}

export const StatusList: React.FC<IStatusListProps> = ({
  currentStatus,
  statusList,
  collapsed,
  setCollapsed,
  onSetNewStatus,
}) => {
  return (
    <div data-testid="StatusList" className={styles['container']}>
      {(collapsed ? statusList.slice(0, 4) : statusList).map(item => {
        return (
          <div key={item.code} className={styles['item']} onClick={() => onSetNewStatus(item)}>
            <UIText1>{item.text}</UIText1>
            {item.code === currentStatus.code && (
              <div className={styles['icon']}>
                <IconFunctionalSuccess16 color="icon-main-default" />
              </div>
            )}
          </div>
        );
      })}
      {collapsed && (
        <div data-testid="StatusListCollapsed" className={styles['more']} onClick={setCollapsed}>
          <div className={styles['more-icon']}>
            <IconActionChevronDownSmall16 color="icon-main-default" />
          </div>
          <UIText1 color="text-main-default">Ещё</UIText1>
        </div>
      )}
    </div>
  );
};

StatusList.displayName = 'StatusList';
